import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Divider from '../divider';
import Heading from '../heading';
import Paragraph from '../paragraph';
import { APPEARANCES } from './constants';

const HeadingGroup = ({
  title,
  description = null,
  appearance = APPEARANCES.default,
  children = null,
}) => {
  const headingGroupClasses = classNames('ws-ui-heading-group', {
    'ws-ui-heading-group--with-description': description,
  });

  return (
    <div className={headingGroupClasses}>
      <div className="ws-ui-heading-group__title">
        <Heading type="heading-5" appearance={appearance}>
          {title}
        </Heading>
      </div>

      <div className="ws-ui-heading-group__divider">
        <Divider appearance={appearance} />
      </div>

      {(description || children) && (
        <div className="ws-ui-heading-group__content">
          {description && (
            <Paragraph size="small" appearance="medium-emphasis">
              {description}
            </Paragraph>
          )}

          {children}
        </div>
      )}
    </div>
  );
};

HeadingGroup.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  appearance: PropTypes.oneOf(Object.values(APPEARANCES)),
  children: PropTypes.node,
};

export default HeadingGroup;
